import Backbone from 'backbone'
import template from './calendar-or-date-range-selector.hbs'
import _ from 'lodash'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import formHelper from 'scoreboard/components/form-helper'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'
import moment from 'moment'
import momentHelper from 'scoreboard/components/moment-helper'
import DateInput from 'scoreboard/components/date-input'
import $ from 'jquery'

const CalendarOrDateRangeSelector = Backbone.View.extend({
	events: {
		'input [name=startDate], [name=endDate]': 'fixBadDates'
	},

	initialize(opt = {}) {
		this.options = opt
	},

	render() {
		this.$el.empty().append(template())

		this.renderToggle()
		this.renderRangeSelector()

		this.date1 = new DateInput({
			el: this.$('input[name=startDate]'),
			required: true,
			initialValue: this.options.dates.startDate
		}).render()

		this.date2 = new DateInput({
			el: this.$('input[name=endDate]'),
			required: true,
			initialValue: this.options.dates.endDate
		}).render()

		// make sure the correct form elements are visible based on choosing by
		// calendar period or day
		this.updateInputVisibility()

		this.listenTo(this.toggle, 'change', this.updateInputVisibility.bind(this))

		_.invokeMap(this.valueOrEquations, 'changeUpdateType')

		return this
	},

	renderToggle: function() {
		this.toggle = new LabeledToggle({
			options: [{
				value: 'calendar-period',
				label: 'common.calendar.calendarPeriod'
			},{
				value: 'day',
				label: 'common.day'
			}],
			value: this.options.chooseBy
		})
		this.$('.toggle-container').append(this.toggle.el)
		this.toggle.render()
	},

	renderRangeSelector() {
		this.rangeSelector = new CalendarRangeSelector(_.extend({
			range: this.options.range,
			canChangeCalendar: true
		}, this.options))

		this.$('.choose-by').after(this.rangeSelector.el)
		this.rangeSelector.render()
	},

	updateInputVisibility: function() {
		var chooseBy = this.toggle.val()

		this.$('.dates').toggleClass('is-not-displayed', chooseBy !== 'day')
		this.rangeSelector.$el.toggleClass('is-not-displayed', chooseBy === 'day')
	},

	fixBadDates: function (e) {
		if (this.options.singlePeriod) {
			return
		}

		fixBadDates(this.date1, this.date2, e)
	},

	val() {
		return {
			chooseBy: this.toggle.val(),
			range: this.rangeSelector.val(),
			dates: formHelper.readFromDom(this.el)
		}
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.toggle, this.date1, this.date2,
			this.rangeSelector], 'remove')
	}
})

/**
 * If only this were a general solution I could sell to eHarmony.
 *
 * Examines the start and end date to see if they are in an order that makes
 * sense chronologically.  If not, both dates are set to whichever date
 * triggered this event handler.
 */
const fixBadDates = function (dateField1, dateField2, e) {
	// Get the value of the date that triggered the event
	let goodDate = $(e.target).val()

	// Fixes #58793 - Parse date values from the fields
	// using moment for strict validation
	let date1 = moment(dateField1.val(), momentHelper.numericDateFormat, true)
	let date2 = moment(dateField2.val(), momentHelper.numericDateFormat, true)

	// Check if both dates are valid and date1 is after date2
	if (date1.isValid() && date2.isValid() && date1.isAfter(date2)) {
		// If date1 is after date2, set both fields to the value of the most recently changed date
		dateField1.val(goodDate)
		dateField2.val(goodDate)
	}
}

export default CalendarOrDateRangeSelector
export { fixBadDates }

CalendarOrDateRangeSelector.__filename__ = 'components/calendar-or-date-range-selector.js'
